export class ApiFailure extends Error {
  constructor(message: string, readonly status: number) { super(message); }
}

export async function api<T = any>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (init?.body && !(init.body instanceof FormData)) headers.set("Content-Type", "application/json");
  const response = await fetch(path, { ...init, headers, credentials: "include" });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new ApiFailure(body?.error?.message ?? `Request failed (${response.status})`, response.status);
  }
  if (response.status === 204) return undefined as T;
  return (await response.json()).data as T;
}

export const json = (method: string, body?: unknown): RequestInit => body === undefined ? { method } : { method, body: JSON.stringify(body) };
